"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactDom = require("react-dom");

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _instanceof(left, right) { if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) { return right[Symbol.hasInstance](left); } else { return left instanceof right; } }

function _classCallCheck(instance, Constructor) { if (!_instanceof(instance, Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * @param {NamedNodeMap} map
 */
function nodeNamedMapToArray(map) {
  var result = {};

  for (var i = 0; i < map.length; i++) {
    var o = map.item(i);

    if (o.nodeName[0] === ':') {
      result[o.nodeName.substr(1)] = JSON.parse(o.value);
    } else {
      result[o.nodeName] = o.value;
    }
  }

  return result;
}

var ReactLoader =
/*#__PURE__*/
function () {
  _createClass(ReactLoader, [{
    key: "element",
    value: function element(el) {
      if (typeof el === 'string') {
        el = document.querySelector(el);
      }

      this.el = el;
    }
  }]);

  function ReactLoader() {
    var el = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;

    _classCallCheck(this, ReactLoader);

    Object.defineProperty(this, "tags", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: new Map()
    });
    this.element(el);
  }

  _createClass(ReactLoader, [{
    key: "render",
    value: function render() {
      var _this = this;

      this.tags.forEach(function (Component, tag) {
        var nodeList = _this.el.getElementsByTagName(tag);

        while (nodeList.length) {
          var node = nodeList[0];
          (0, _reactDom.render)(_react.default.createElement(Component, nodeNamedMapToArray(node.attributes)), node);
          node.parentElement.replaceChild(node.firstChild, node);
        }
      });
    }
  }, {
    key: "component",
    value: function component(tag, Component) {
      this.tags.set(tag, Component);
    }
  }]);

  return ReactLoader;
}();

exports.default = ReactLoader;